module.exports = __webpack_public_path__ + "img/gxwl.7249e033.jpg";